<template>
    <div :class="['fillable-bullet']">
        <div :class="['fillable-bullet__label', isFilled ? 'active' : '']">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue';

export default defineComponent({
    name: 'FillableBullet',
    props: {
        isFilled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { isFilled } = toRefs(props);

        return {
            isFilled,
        };
    },
});
</script>
